import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { adminDropdownOptionStyles } from 'components/AdminSearchSelect/component.styles'

export const ColumnsWrapper = styled.div`
  display: flex;
  gap: 1rem;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 7rem;
`

export const ColumnHeader = styled.div`
  align-items: center;
  display: flex;
`

export const ColumnTitle = styled.span`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.regular')};
  font-size: 0.75rem;
  letter-spacing: 0.02em;
  line-height: 1.3125rem;
  text-transform: uppercase;
  white-space: nowrap;
`

export const ColumnHairline = styled.span`
  background: ${themeGet('colors.gray500')};
  flex: 1;
  height: 2px;
  min-width: 0.875rem;
  margin-left: 0.5rem;
`

export const ColumnLinksList = styled.div`
  display: flex;
  flex-direction: column;
`

export const ColumnLink = styled.button`
  ${adminDropdownOptionStyles}
  padding: 0.22rem 0;
  white-space: nowrap;

  &.arrow-selected {
    color: ${themeGet('colors.secondStepBlue')};
  }
`
